import { Container, Paper, Box } from "@mui/material";

export default function FormPage({ children }) {
  return (
    <Box
      sx={{
        backgroundColor: "#faf8f5",
        minHeight: "100vh",
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            border: "1px solid",
            borderColor: "grey.200",
            borderRadius: 4,
            p: { xs: 3, md: 5 },
          }}
        >
          {children}
        </Paper>
      </Container>
    </Box>
  );
}
